import { Link } from "react-router-dom";
import { homeCategories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategoryStrip() {
  return (
    <section className="w-full px-4 md:px-8 mt-16 md:mt-20">
      <SectionHeading
        eyebrow="Browse by genre"
        title="按题材浏览"
        desc="从喜欢的题材出发，快速找到对应的电影内容"
        moreTo="/category"
        moreLabel="全部分类"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {homeCategories.map((c, i) => (
          <Link
            key={c.name}
            to={`/category?genre=${encodeURIComponent(c.name)}`}
            className="reveal group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
            style={{ transitionDelay: `${i * 30}ms` }}
          >
            <span className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${c.icon} text-2xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {c.name}
              </span>
              <span className="block text-xs text-foreground-500 truncate">{c.desc}</span>
            </span>
            <i className="ri-arrow-right-line ml-auto text-foreground-300 group-hover:text-accent-500 transition-colors"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}